export const CompanyHotelQueryKeys = {
	all: ['company-hotel'] as const,
	list: () => [...CompanyHotelQueryKeys.all, 'list'] as const,
	detail: (id: number) => [...CompanyHotelQueryKeys.all, 'details', id] as const,
};